export default __webpack_public_path__ + "static/media/white_iron_greatsword.eda6295d.png";